import React from 'react';
import {
  XMarkIcon as HeroXMarkIcon,
  ExclamationCircleIcon as HeroExclamationCircleIcon,
  ComputerDesktopIcon as HeroComputerDesktopIcon,
} from '@heroicons/react/24/outline';

/** Icono de monitor / escritorio */
export const ComputerDesktopIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroComputerDesktopIcon className={className} aria-hidden="true" />
);

/** Icono de advertencia en círculo */
export const ExclamationCircleIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroExclamationCircleIcon className={className} aria-hidden="true" />
);

/** Icono de X para cerrar/cancelar */
export const CloseIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroXMarkIcon className={className} aria-hidden="true" />
);
